import { combineReducers } from "redux";
import authReducer from "./auth/AuthReducer";
import employeeReducer from "./employee/EmployeeReducer";
import customerReducer from "./customer/CustomerReducer";
import transactionReducer from "./transaction/TransactionReducer";
import notificationReducer from "./notification/NotificationReducer";
import dashboardReducer from "./dashboard/DashboardReducer";
import dashBoardTotalActiveUserReducer from "./dashboard/DashboardActiveCustomerReducer";
import dashBoardTotalSalesReducer from "./dashboard/DashboardTotalSalesReducer";
import dashBoardTotalRewardReducer from "./dashboard/DashboardRewardReceivedReducer";
import dashBoardRewardRedeemReducer from "./dashboard/DashboardRewardRedeemReducer";
import dashBoardRecentCustomersReducer from "./dashboard/DashboardRecentCustomersReducer";
import dashBoardRecentTransactionReducer from "./dashboard/DashboardRecentTransactionReducer";
import rolesReducer from "./role/RoleReducer";
import dashBoardSaleReportReducer from "./dashboard/DashboardSaleReportReducer";
import reportsReducer from "./reports/ReportsReducer";
import TransactionReportReducer from "./reports/TransactionReportReducer";
import dashboardCurrentGoldPriceReducer from "./dashboard/DashboardCurrentGoldPrice";
import InstoreRequestReducer from "./InstoreRequest/InstoreRequestReducer";

const rootReducer = combineReducers({
  user: authReducer,
  employee: employeeReducer,
  customer: customerReducer,
  transaction: transactionReducer,
  notification: notificationReducer,
  role: rolesReducer,
  dashboard: dashboardReducer,
  dashBoardTotalActiveUser: dashBoardTotalActiveUserReducer,
  dashBoardTotalSales: dashBoardTotalSalesReducer,
  dashBoardTotalReward: dashBoardTotalRewardReducer,
  dashBoardRewardRedeem: dashBoardRewardRedeemReducer,
  dashBoardRecentCustomers: dashBoardRecentCustomersReducer,
  dashBoardRecentTransaction: dashBoardRecentTransactionReducer,
  dashBoardSaleReport: dashBoardSaleReportReducer,
  reports: reportsReducer,
  transactionReport: TransactionReportReducer,
  dashboardCurrentGoldPrice: dashboardCurrentGoldPriceReducer,
  inStoreRequest: InstoreRequestReducer
});

export default rootReducer;
